import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class GetStockPricesRequest extends BaseServiceRequestIIS {
    constructor() {
        super();
    }

    getServiceMethod() {
        return "GetStockPrices";
    }
    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return 'CurrentPrice';
    }
}

export default GetStockPricesRequest;